import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailIcon from "@mui/icons-material/Mail";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import MoreIcon from "@mui/icons-material/MoreVert";
import { Link, useLocation } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateHomeSearchValue,
  updateSearch,
  updateSearchObject,
  updateSearchValue,
} from "../../store/features/search";
import { fetchNotice } from "../../store/features/notification";
import { Autocomplete, TextField } from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";

import { useAlert } from "../AlertProvider/AlertProvider";

const CustomAutocomplete = styled(Autocomplete)({
  marginLeft: "50px", // 设置左边距
  "& .MuiFormLabel-root": {
    // 默认状态的 transform 样式
    transform: "translate(0, 8px)",

    // 聚焦状态的 transform 样式
    "&.Mui-focused": {
      opacity: 0,
    },
  },

  "& .MuiInputBase-root": {
    "& fieldset": {
      border: "none", // 移除边框
    },
    "&:hover fieldset": {
      border: "none", // 移除悬浮时的边框
    },
    "&.Mui-focused fieldset": {
      // transform:'none',
      // border: 'none', // 移除聚焦时的边框
    },
    padding: "1px",
    backgroundColor: "transparent", // 设置背景透明
    fontSize: "16px", // 设置字体大小
  },
});

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.0),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.0),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
  color: "#FF7E07",
  border: "1px solid #FF7E07",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  "& .MuiInputBase-input ::placeholder": {
    color: "black !important", // 修改 placeholder 文字颜色为灰色
  },
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    marginLeft: `10px`,
    transition: theme.transitions.create("width"),
    backgroundColor: "transparent",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

export default function Header() {
  const tempName = useRef("");
  const [show, setShow] = useState(true);
  const [uisearchValue, setUISearchValue] = useState("");
  const { searchValue } = useSelector((store) => store.search);
  const { mapData } = useSelector((store) => store.maps);
  const { blurAnswer, setBlurAnswer } = useState([]);
  const showAlert = useAlert();
  const inputRef = React.useRef(null);
  const dispatch = useDispatch();
  // const history = useHistory();

  const handleHomeSearchChange = (event, value) => {
    // dispatch(updateHomeSearchValue(value));
  };

  const handleSearchChange = (event, newValue) => {
    if (newValue) {
      if (newValue.name) {
        dispatch(updateSearchValue(newValue.name));
      } else if (newValue.length > 0) {
        dispatch(updateSearchValue(newValue));
      }
    }
  };
  const handleSearchSubmit = () => {
    // 在这里发送搜索内容到服务器
    console.log("搜索内容:", searchValue);
    if (searchValue && searchValue.length > 0) {
      navigate(`/yetai?type=0&keyword=${searchValue}`);
    }
    return;

    return;
    if (searchValue && searchValue.length > 0) {
      if (mapData) {
        let answer = mapData.find((item) => {
          return item.name == searchValue;
        });

        if (answer) {
          //更新cookie
          dispatch(updateSearch(searchValue));
          dispatch(updateSearchObject(answer));
          navigate(`/home`);
        } else {
          showAlert("找不到该村庄信息");
        }
      }
    }
  };

  const handleSearchClick = (e) => {
    // 在这里执行您想要的操作
    e.stopPropagation();
    console.log("搜索框被点击了！");
  };
  const handleNoticeClick = () => {
    window.localStorage.setItem("noticeClickTime", new Date());
    setInvisible(true);
  };

  const navigate = useNavigate();

  const location = useLocation();
  const [showback, setshowback] = React.useState(false);
  const [inSearch, setinSearch] = React.useState(false);
  const [invisible, setInvisible] = React.useState(false);
  const [currentPath, setCurrentPath] = React.useState(location.path);

  React.useEffect(() => {
    // 当路由发生变化时执行的操作
    console.log("当前路由:", location.pathname);
    if (
      location.pathname == "/my" ||
      location.pathname == "/advice" ||
      location.pathname == "/yetaidetail" ||
      location.pathname == "/linedetail"
    ) {
      setShow(false);
    } else {
      setShow(true);
    }

    // if (location.pathname == '/yetaidetail') {
    //   setshowback(true);
    // }
    // else {
    //   setshowback(false);
    // }

    //深色边框
    if (
      location.pathname == "/search" ||
      location.pathname == "/notification" ||
      location.pathname == "/yetai"
    ) {
      setinSearch(true);
    } else {
      setinSearch(false);
    }

    setCurrentPath(location.pathname);
  }, [location]); // 仅当 location 发生变化时执行

  // 移除旧的搜索逻辑，现在搜索直接在 home 页面处理

  React.useEffect(() => {
    setInvisible(true);
    dispatch(fetchNotice()).then((s) => {
      if (s.payload.item && s.payload.item.length > 0) {
        //要重写，和updateTime绑定
        let localTime = new Date(
          window.localStorage.getItem("noticeClickTime")
        );
        if (localTime && localTime < new Date(s.payload.item[0].updated_at)) {
          setInvisible(false);
          tempName.current = s.payload.item[0].name;
        }
      }
    });
  }, []);

  const filterOptions = createFilterOptions({
    stringify: (option) => {
      return option.name;
    },
  });
  const [inputValue, setInputValue] = useState("");
  const menuId = "primary-search-account-menu";
  const backHandler = () => {
    navigate(-1);
  };
  return (
    show && (
      <AppBar
        position="fixed"
        style={{
          top: ".5rem",
          backgroundColor: "rgba(255,0,0,0.0)",
          boxShadow: "none",
        }}
      >
        <Toolbar
          style={{
            border: inSearch ? "1px solid #666666" : "none",
            backgroundColor: "rgba(255,255,255,0.75)",
            padding: 0,
            minHeight: "35px",
            margin: "1rem",
            boxShadow: "none",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {showback && (
            <ArrowBackIosIcon
              onClick={backHandler}
              sx={{ display: { xs: "flex", md: "flex" }, mr: 1, color: "#000" }}
            />
          )}
          {!showback && (
            <React.Fragment>
              {/* {(currentPath == '/') || (currentPath == '/home') ? */}
              {false ? (
                // 首页不用跳转serach路由
                <Search
                  sx={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: 0,
                  }}
                >
                  <SearchIconWrapper>
                    <SearchIcon sx={{ color: "#000" }} />
                  </SearchIconWrapper>
                  <CustomAutocomplete
                    onChange={handleHomeSearchChange}
                    clearOnBlur
                    id="free-solo-demo"
                    freeSolo
                    getOptionLabel={(option) => option.name} // 显示 name 属性
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    )}
                    options={mapData ? mapData.map((option) => option) : []}
                    renderInput={(params) => (
                      <TextField {...params} label="搜索 | 嘉兴最美乡村" />
                    )}
                  />
                </Search>
              ) : (
                <Search
                  sx={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: 0,
                    width: "84%",
                  }}
                >
                  <SearchIconWrapper>
                    <SearchIcon sx={{ color: "#000" }} />
                  </SearchIconWrapper>
                  <CustomAutocomplete
                    style={{ width: "100%" }}
                    value={uisearchValue}
                    onChange={(event, newValue) => {
                      // 选择选项时触发搜索
                      if (newValue) {
                        let searchText = typeof newValue === "string" ? newValue : newValue.name;
                        if (searchText) {
                          dispatch(updateSearchValue(searchText));
                          setUISearchValue("");
                          inputRef.current?.blur();
                        }
                      }
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    clearOnBlur
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        // 按 Enter 键确认搜索
                        const searchText = event.target.value || inputValue;
                        if (searchText && searchText.trim()) {
                          dispatch(updateSearchValue(searchText.trim()));
                          setUISearchValue("");
                          setInputValue("");
                          inputRef.current?.blur();
                        }
                      }
                    }}
                    onFocus={() => {
                      console.log("onFocus!!!!!!!!!!!!!");
                    }}
                    onBlur={() => {
                      console.log("onBlur!!!!!!!!!!!!!");
                      // 不清空，保持搜索状态
                    }}
                    id="free-solo-demo"
                    freeSolo
                    getOptionLabel={(option) => {
                      if (typeof option === "string") {
                        return option;
                      }
                      return option.name || "";
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    )}
                    filterOptions={(options, state) => {
                      if (state.inputValue.length === 0) {
                        return [];
                      }
                      return filterOptions(options, state);
                    }}
                    options={mapData ? mapData.map((option) => option) : []}
                    renderInput={(params) => (
                      <TextField
                        inputRef={inputRef}
                        {...params}
                        label="搜索 | 鄂州市土特产"
                      />
                    )}
                  />
                </Search>
              )}
              {/* <Box sx={{ flexGrow: 1 }} /> */}
              {(currentPath == "/" || currentPath == "/home") && (
                <Link to="/notification" onClick={handleNoticeClick}>
                  <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                    <IconButton size="media" style={{ color: "black" }}>
                      <Badge invisible={invisible} variant="dot" color="error">
                        <NotificationsActiveOutlinedIcon
                          sx={{ fontWeight: "normal" }}
                        />
                      </Badge>
                    </IconButton>
                  </Box>
                </Link>
              )}
            </React.Fragment>
          )}
        </Toolbar>
      </AppBar>
    )
  );
}
